import React from 'react';
import { Copy } from '@grubhubprod/gh-cookbook-react';
import { useBusinessInsightsContext } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/hooks/useBusinessInsightsContext';
import { formatInsightsDataLastUpdated } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsDashboardLastUpdatedStatus/InsightsDashboardLastUpdatedStatus.utils';

export function InsightsDashboardLastUpdatedStatus(): JSX.Element | null {
  const { dataLastUpdated } = useBusinessInsightsContext();

  const formattedDate = formatInsightsDataLastUpdated(dataLastUpdated);

  if (!formattedDate) {
    return null;
  }

  return (
    <Copy variant="body" color="secondaryText" whiteSpace="nowrap">
      Data last updated: {formattedDate}
    </Copy>
  );
}
